module.exports = __webpack_public_path__ + "media/images/emblems/Grancia-coat_of_arms-aa06e17b66e080e89e078d80cd7b1123.svg";